import Vue from 'vue'
import Vuex from 'vuex'
// import { stat } from 'fs';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        drawer: true,
        
    },
    mutations: {
        setDrawer(state, tmp){
            state.drawer = tmp
        },
    },
    getters: {
        drawer: state => state.drawer,
    }
})
